import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_CONCEPTOS = 'ALL_CONCEPTOS';
export const LOADING_ALL_CONCEPTOS = 'LOADING_ALL_CONCEPTOS';
export const ACTIVO_CONCEPTOS = 'ACTIVO_CONCEPTOS';
export const PARAMS_CONCEPTOS = 'PARAMS_CONCEPTOS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const conceptosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_CONCEPTOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_CONCEPTOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_CONCEPTOS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_CONCEPTOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
